import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private defaultConfig: MatDialogConfig = {
    disableClose: true,
    autoFocus: false,
    restoreFocus: false,
    hasBackdrop: true,
    maxWidth: 'min(600px, 80vw)',
    width: '100%'
  }

  constructor(private dialog: MatDialog) {
  }

  openDialog(component: any, config: MatDialogConfig) {
    const dialogConfig = {
      ...this.defaultConfig,
      ...config
    }
    return this.dialog.open(component, dialogConfig);
  }
}
